"use strict";import{IconOpenIn as n}from"../src/elements/IconOpenIn.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-icon-open-in",n);
//# sourceMappingURL=sp-icon-open-in.js.map
